import Employee from './Employee';
import Staff from './Staff';
import Pin from './Pin';
import Role from './Role';

export { Staff, Pin, Role };
export default Employee;
